import React from 'react'

export default function NewUpsl() {
  return (
    <div className='bg-white border p-4 fs-7'></div>
  )
}
